import { createRoutesFromElements, redirect, Route } from 'react-router-dom';
import {
  getSongIdFromUrlSongParams,
  isAIGeneratedSong,
} from 'hooks/useSongId/helpers';
import { HiddenTopBarAndFooter } from 'layouts';
import { AppErrorManager } from 'errorHelper';
import LayoutAdapter from 'layouts/LayoutAdapter';
import { RemixerProjectContainer, RemixerSongContainer } from 'pages/Remixer';
import { locations } from './locations';

export default createRoutesFromElements(
  <Route
    id="studio"
    path={locations.studio.routeSegment}
    element={<LayoutAdapter Layout={HiddenTopBarAndFooter} />}
  >
    <Route
      id="studio-song"
      path={locations.studio.song.route}
      loader={({ params: { songParams } }) => {
        const redirectUrl = locations.other.blankPage.pathname;

        if (!songParams) {
          return redirect(redirectUrl);
        }

        try {
          const isAIGenerated = isAIGeneratedSong(songParams);
          const id = getSongIdFromUrlSongParams(songParams);

          if (!id) {
            return redirect(redirectUrl);
          }

          return {
            isAIGenerated,
            id,
          };
        } catch (error) {
          AppErrorManager.sendError(error, {
            extra: {
              songParams,
            },
          });
          return redirect(redirectUrl);
        }
      }}
      element={<RemixerSongContainer />}
    />
    <Route
      id="studio-project"
      path={locations.studio.project.route}
      element={<RemixerProjectContainer />}
    />
  </Route>
);
